import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { bool, func, shape, string, oneOfType, number } from 'prop-types';
import { LIST } from '../../constants';
import { Price } from '../../molecules';
import { HiddenPriceContainer, ShowPriceButton } from './product-card-price.styles';

const ProductCardPrice = ({
  hide,
  hiddenPrice,
  displayMode,
  installment,
  showInCashInfo,
  showDiscount,
  showDiscountOnlyCashInfo,
  price,
  hidePriceButtonAction,
  hideOriginalPrice,
  product
}) => {
  if (hide) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, !hiddenPrice && /*#__PURE__*/React.createElement(Price, _extends({
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: installment,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    hideOriginalPrice: hideOriginalPrice
  }, price)), hiddenPrice && /*#__PURE__*/React.createElement(HiddenPriceContainer, null, /*#__PURE__*/React.createElement("span", {
    "data-testid": "hided-price"
  }, /*#__PURE__*/React.createElement(Price, {
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: null,
    price: 0.0,
    showInCashInfo: showInCashInfo
  })), hidePriceButtonAction && /*#__PURE__*/React.createElement(ShowPriceButton, {
    full: true,
    size: "small",
    m: '10px 0',
    "data-testid": "show-price-button",
    onClick: e => {
      e.preventDefault();
      hidePriceButtonAction(product);
    }
  }, "Ver Pre\xE7o")));
};

export default ProductCardPrice;
process.env.NODE_ENV !== "production" ? ProductCardPrice.propTypes = {
  hide: bool,
  hiddenPrice: bool,
  displayMode: string,
  installment: shape({
    amount: oneOfType([string, number]),
    paymentMethodDescription: string,
    quantity: oneOfType([string, number]),
    totalAmount: oneOfType([string, number])
  }),
  showInCashInfo: bool,
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  price: shape({}),
  hidePriceButtonAction: func,
  product: shape({}),
  hideOriginalPrice: bool
} : void 0;
ProductCardPrice.defaultProps = {
  hide: false,
  hiddenPrice: false,
  displayMode: LIST,
  installment: {},
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: true,
  price: {},
  hidePriceButtonAction: null,
  product: {},
  hideOriginalPrice: false
};